import { paths } from "from-start/scene/resources";
import { html, LitElement } from "lit-element";
class JhOpeningEnterButton extends LitElement {
    constructor() {
        super();
        this.state = "ready";
    }
    static get properties() {
        return {
            state: { type: String, reflected: true },
        };
    }
    createRenderRoot() {
        return this;
    }
    render() {
        if (this.state === "ready") {
            return html `<button
        id="opening-enter-button"
        class="bn absolute"
        @click="${this.handleClick}"
      ></button>`;
        }
        else {
            return html ` <img src="${paths.openingClicked}" /> `;
        }
    }
    handleClick() {
        this.state = "clicked";
    }
}
customElements.define("jh-opening-enter-button", JhOpeningEnterButton);
//# sourceMappingURL=enterButton.js.map